<template>
  <!---->
  <!--<p>{{ items }}</p> 
    <div v-for="item in items" :key="item" class="item">
      {{ item.data_year }}:
      {{ item.sector }}
      {{ item.category_details }}
  </div>-->

  <div class="hello">
    <!--<span v-for="item in items" :key="item">{{ item.Price }}</span>-->

    <overpopcharts class="chart" :updateArgs="[true, true, true]" :options="chartOptions"></overpopcharts>
  </div>
</template>

<script>
import BAU from "@/components/json/BAUdata.json";

import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import drilldownInit from "highcharts/modules/drilldown";
import exportingInit from "highcharts/modules/exporting";
//import stockInit from "highcharts/modules/stock";

import { EventBus } from "@/event-bus.js";

//stockInit(Highcharts);
exportingInit(Highcharts);
drilldownInit(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: ".",
    thousandsSep: ","
  }
});

var WasteData = [],
  AgricultureData = [],
  IPData = [],
  EnergyData = [];

for (var i = 0; i < BAU.length; i++) {
  if (BAU[i].Price === "0") {
    if (BAU[i].sector === "Waste") {
      WasteData.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Agriculture") {
      AgricultureData.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Industrial") {
      IPData.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
    if (BAU[i].sector === "Energy") {
      EnergyData.push(parseFloat(BAU[i].Residual.replace(/,/g, "")));
    }
  }
}

export default {
  props: {
    partsdata: {
      type: Array
    }
  },
  name: "hello",
  components: {
    overpopcharts: Chart
  },

  created() {
    EventBus.$on("bau-clicked", data => {
      this.chartOptions.series[1].data = data.newWasteData;
      this.chartOptions.series[2].data = data.newIPData;
      this.chartOptions.series[3].data = data.newEnergyData;
      this.chartOptions.series[4].data = data.newAgricultureData;
    });
  },

  data() {
    return {
      items: BAU,
      chartOptions: {
        lang: {
          thousandsSep: ","
        },
        chart: {
          type: "area"
        },
        title: {
          text: "BAU Emission Projections and Residual Emissions by Sector"
        },
        legend: {
          enabled: true,
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          floating: false,
          borderWidth: 1,
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || "#FFFFFF"
        },
        xAxis: {
          categories: [
            "2015",
            "2020",
            "2025",
            "2030",
            "2035",
            "2040",
            "2045",
            "2050"
          ]
        },
        tooltip: {
          pointFormat: "Value: {point.y:,.0f}"
        },
        yAxis: {
          title: {
            useHTML: true,
            text: "tCO<sub>2</sub>e"
          }
        },
        plotOptions: {
          area: {
            stacking: "normal",
            lineColor: "#666666",
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: "#666666"
            }
          }
        },
        credits: {
          enabled: false
        },

        series: [
          {
            name: "Baseline",
            data: baselinesum,
            dashStyle: "longdash",
            type: "line",
            zIndex: 1,
            marker: {
              fillColor: "white",
              lineWidth: 2,
              lineColor: Highcharts.getOptions().colors[0]
            }
          },

          {
            name: "Waste",
            data: WasteData
          },

          {
            name: "Industrial Processes",
            data: IPData
          },
          {
            name: "Energy",
            data: EnergyData
          },
          {
            name: "Agriculture",
            data: AgricultureData
          }
        ]
      }
    };
  }
};
var baselinesum = [
  ["2015", 10892],
  ["2020", 11472],
  ["2025", 12186],
  ["2030", 12849],
  ["2035", 13274],
  ["2040", 13883],
  ["2045", 14470],
  ["2050", 15119]
];

//alert(IPData);
</script>
